import { TASK_DRAWER_OPEN, TASK_DRAWER_CLOSE } from './constants';

export const openTaskDrawer = () => ({ type: TASK_DRAWER_OPEN });

export const closeTaskDrawer = () => ({ type: TASK_DRAWER_CLOSE });
